<div *ngIf="teaser.foregroundImage && isMobileImage" [ngClass]="'opt-teaser-fg-img-' + (imagePosition | lowercase)">
    <img [src]="teaser.foregroundImage.src" />
</div>
<div *ngIf="teaser.desktopForegroundImage && !isMobileImage" [ngClass]="'opt-teaser-fg-img-' + (imagePosition | lowercase)">
    <img [src]="teaser.desktopForegroundImage.src" />
</div>
